var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.74 0H0.24C0.174567 0.00504797 0.113464 0.0346537 0.0689501 0.0828769C0.0244364 0.1311 -0.00019424 0.194373 1.90066e-07 0.26V1.12C-0.000600638 1.20815 0.0163295 1.29553 0.049806 1.37708C0.0832824 1.45863 0.132637 1.5327 0.195 1.595L6.195 7.595V12.595L9.82 14.4V7.585L15.82 1.585C15.9348 1.46118 15.999 1.29884 16 1.13V0.26C16 0.191044 15.9726 0.124912 15.9238 0.0761523C15.8751 0.0273929 15.809 0 15.74 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.07b47f87a5c4ebb46bc767c868f0716f.svg";
export { ForwardRef as ReactComponent };